function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.83333 6.33333H5.84167M5.83333 3H10C10.4266 2.99999 10.8531 3.16271 11.1785 3.48816L17.0119 9.32149C17.6628 9.97236 17.6628 11.0276 17.0119 11.6785L11.1785 17.5118C10.5276 18.1627 9.47236 18.1627 8.82149 17.5118L2.98816 11.6785C2.66272 11.3531 2.5 10.9265 2.5 10.5V6.33333C2.5 4.49238 3.99238 3 5.83333 3Z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
function SvgLiveDeals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "1.75 2.25 16.5 16.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveDeals);
export default __webpack_public_path__ + "static/media/live-deals.06ffe8ee.svg";
export { ForwardRef as ReactComponent };